import ApiBase from './apibase';

const CATEGORY_MAX_WEIGHT = 1000;

/**
 * Api sugerencias
 */
class Sugerencias extends ApiBase {
  /**
   * @param {object} config
   */
  constructor(config, target = undefined) {
    super('personalizacion', config, target);
  }

  /**
   * Recomendar temas en base al entrenamiento del usuario
   * @param {Number} [quantity] - hasta cuantos resultados devolver
   * @param {Number[]} [hours] - en que horas buscar
   * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
   * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
   * @param {String[]} [tags]
   */
  recomendarTemas(quantity = 10, hours = [], daysOfWeek = [], user = true, tags = []) {
    const params = {};
    params.quantity = quantity || 10;
    params.hours = hours || [];
    params.daysOfWeek = daysOfWeek || [];
    params.user = user;
    params.tags = tags || [];

    return this.addTask('personalizacion', 'json', [ // recomendar/temas
      {
        name: 'recomendar_temas',
        params
      }
    ]);
  }

  /**
   * Registra los preferibles que se encuentran en la nota a la que accede el usuario.
   * @param {Any} categoriesParam - array de categorias (preferibles) a entrenar. formato esperado: idPreferible#tipoPreferibleId#SubTipoPreferibleId
   * @param {Array} context
   */
  registrarTemas(categoriesParam, context = []) {
    const params = {};
    params.categories = Sugerencias.getCategoriesFrom(categoriesParam);

    const now = new Date();
    const hour = now.getHours();
    const dayOfWeek = now.getDay();

    params.hour = hour;
    params.dayOfWeek = dayOfWeek;

    if (context) params.context = context;

    return this.addTask('personalizacion', 'json', [ // registrar/temas
      {
        name: 'registrar_navegacion',
        params
      }
    ]);
  }

  /**
   * Registra el acceso a una url
   * @param {Any} categoriesParam - array de accesos a entrenar. formato esperado: descripcion|url|tipo
   * @param {Array} context
   */
  registrarAccesos(categoriesParam, context = []) {
    const params = {};
    params.categories = Sugerencias.getCategoriesFrom(categoriesParam);

    const now = new Date();
    const hour = now.getHours();
    const dayOfWeek = now.getDay();

    params.hour = hour;
    params.dayOfWeek = dayOfWeek;

    if (context) params.context = context;

    return this.addTask('personalizacion', 'json', [
      {
        name: 'registrar_acceso',
        params
      }
    ]);
  }

  /**
   * Obtiene los accesos entrenados
   * @param {Number} [quantity] - hasta cuantos resultados devolver
   * @param {Number[]} [hours] - en que horas buscar
   * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
   * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
   * @param {String[]} [tags]
   */
  obtenerAccesos(quantity = 10, hours = [], daysOfWeek = [], user = true, tags = []) {
    const params = {};
    params.quantity = quantity || 10;
    params.hours = hours || [];
    params.daysOfWeek = daysOfWeek || [];
    params.user = user;
    params.tags = tags || [];

    return this.addTask('personalizacion', 'json', [
      {
        name: 'obtener_accesos',
        params
      }
    ]);
  }

  /**
   * Registrar accion sobre contendio
   * @param {Number} contenidoId - Id del contenido 
   * @param {Number} contenidoTipoId - Id del tipo de contenido (1:nota)
   * @param {String} [accion] - acción a entrenar
   */
  registrarAccion(contenidoId, contenidoTipoId, accion = 'lectura') {
    return this.addTask('personalizacion', 'json', [
      {
        name: 'registrar_accion',
        params: [contenidoId, contenidoTipoId, accion]
      }
    ]);
  }

  /**
   * Registra lectura de nota
   * @param {Number} notaId - Id de la nota
   */
  lecturaNota(notaId) {
    return this.addTask('personalizacion', 'json', [
      {
        name: 'registrar_lectura_nota',
        params: [notaId]
      }
    ]);
  }

  /**
   * @param {Number[]} [contenidosLeidos] - array con los id's de notas que se quieren excluir de la busqueda
   * @param {Number} [quantity] - hasta cuantos resultados devolver
   * @param {Number[]} [hours] - en que horas buscar
   * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
   * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
   * @param {String[]} [tags]
   */
  obtener(contenidosLeidos = [], quantity = 10, hours = [], daysOfWeek = [], user = true, tags = []) {
    const params = {};

    params.quantity = quantity <= 0 ? 10 : quantity;
    params.contenidosLeidos = contenidosLeidos;
    params.hours = hours || [];
    params.daysOfWeek = daysOfWeek || [];
    params.user = user;
    params.tags = tags || [];

    return this.addTask('personalizacion', 'json', [
      {
        name: 'obtener_sugerencias',
        params
      }
    ]);
  }
}

/**
   * Convert a single value to category object
   * @param  {Any} categoryParam
   * @return  {object} category
   **/
Sugerencias.getCategory = (categoryParam) => {
  if (typeof categoryParam === 'string') {
    return categoryParam;
  }

  const category = {};
  if (typeof categoryParam === 'object') {
    category.value = categoryParam.value;
    if (categoryParam.type) category.type = categoryParam.type;
    else if (categoryParam.weight > CATEGORY_MAX_WEIGHT) category.weight = CATEGORY_MAX_WEIGHT;
    else if (categoryParam.weight) category.weight = categoryParam.weight;
    else category.weight = 1;
  } else {
    category.value = categoryParam;
    category.weight = 1;
  }

  return category;
};

/**
   * Convert values to array of categories
   * @param  {Any} categories
   * @return  {Array} categories
   **/
Sugerencias.getCategoriesFrom = (categories) => {
  if (categories instanceof Array) {
    return [...categories.map(Sugerencias.getCategory).filter(c => !!c)];
  } else if (typeof categories === 'object') {
    return categories.categories || categories;
  }
  return [Sugerencias.getCategory(categories)];
};

export default Sugerencias;



// WEBPACK FOOTER //
// ./~/@ln/personalizacion/sugerencias.js